module.exports = __webpack_public_path__ + "img/video6.e7097c78.jpg";